<div class="price-request-form__error-message" *ngIf="formError ? (studentFormValid$ | async) === false : false">
  <lx-form-error-message ngProjectAs="additional-info"></lx-form-error-message>
</div>
<p-accordion
  class="form-field__single-border-input"
  (activeIndexChange)="activeIndexChange($event)"
  (onClose)="showSummary($event?.index)"
  (onOpen)="hideSummary($event?.index)"
  [activeIndex]="activeIndex"
  [expandIcon]="' '"
  [collapseIcon]="' '"
>
  <p-accordionTab iconPos="end">
    <ng-template pTemplate="header">
      <div class="price-request-form__tab-header" #priceRequestForm>
        <div class="price-request-form__tab-header__header">
          <div class="price-request-form__tab-header__header__title">
            <div class="price-request-form__tab-header__header__title__step" i18n>Step 1 of 2</div>
            <div i18n>Program and school</div>
          </div>
          <div class="price-request-form__tab-header__header__icon">
            <i class="pi" [ngClass]="{ 'pi-circle-off': (courseFormValid$ | async) === false, 'pi-check-circle': (courseFormValid$ | async) === true }"></i>
          </div>
        </div>

        <ng-container *ngIf="quoteInputSummary.length > 0 && quoteInputSummaryVisible">
          <div class="price-request-form__tab-header__info-panel">
            <div class="price-request-form__tab-header__info-panel__summary-info">
              {{ quoteInputSummary }}
            </div>
            <div class="price-request-form__tab-header__info-panel__edit-button">
              <lx-button
                id="btn-edit-course-form"
                data-qa="qt-edit-course-form"
                i18n-text
                text="Edit"
                [uppercase]="true"
                [buttonStyle]="'link'"
                (buttonClick)="editForm($event, formIndexes.courseForm)"
              >
              </lx-button>
            </div>
          </div>
        </ng-container>
      </div>
    </ng-template>
    <ng-template pTemplate="content">
      <lx-price-request-course-form [columns]="1"></lx-price-request-course-form>
      <div class="price-request-form__button-container">
        <lx-button
          [class.price-request-form__button-container__button--inline-cta]="withPriceRequestInlineCtaExperimentActive"
          class="price-request-form__button-container__button"
          id="btn-next"
          data-qa="qt-next-button"
          icon="pi pi-chevron-down"
          i18n-text
          text="Next"
          [hasText]="true"
          [block]="true"
          iconPos="after"
          [disabled]="(courseFormValid$ | async) === false"
          [uppercase]="true"
          [buttonStyle]="'primary'"
          (buttonClick)="activeIndexChange(formIndexes.studentForm)"
          [lxGAClickEvent]="PriceRequestFormGoogleAnalyticsEvent.QuoteNext"
        >
        </lx-button>
      </div>
    </ng-template>
  </p-accordionTab>
  <p-accordionTab iconPos="end" [disabled]="(courseFormValid$ | async) === false">
    <ng-template pTemplate="header">
      <div class="price-request-form__tab-header">
        <div class="price-request-form__tab-header__header">
          <div class="price-request-form__tab-header__header__title">
            <div class="price-request-form__tab-header__header__title__step" i18n>Step 2 of 2</div>
            <div i18n>Your details</div>
          </div>
          <div class="price-request-form__tab-header__header__icon">
            <i class="pi" [ngClass]="{ 'pi-circle-off': (studentFormValid$ | async) === false, 'pi-check-circle': (studentFormValid$ | async) === true }"></i>
          </div>
        </div>
        <ng-container [ngTemplateOutlet]="studentDetailsTemplate" [ngTemplateOutletContext]="{ studentDetails: studentDetails$ | async }"></ng-container>

        <ng-template #studentDetailsTemplate let-studentDetails="studentDetails">
          <ng-container *ngIf="filledStudentDetails && studentDetailsSummaryVisible">
            <div class="price-request-form__tab-header__info-panel">
              <div class="price-request-form__tab-header__info-panel__summary-info">
                <div class="price-request-form__tab-header__info-panel__summary-info__student-details">
                  <div class="price-request-form__tab-header__info-panel__summary-info__student-details__name">
                    {{ studentDetails?.firstName }} {{ studentDetails?.lastName }}
                  </div>
                  <div class="price-request-form__tab-header__info-panel__summary-info__student-details__contact">
                    {{ studentDetailsContactInfoSummary }}
                  </div>
                  <div class="price-request-form__tab-header__info-panel__summary-info__student-details__address">
                    {{ studentDetailsAddressSummary }}
                  </div>
                </div>
              </div>
              <div class="price-request-form__tab-header__info-panel__edit-button">
                <lx-button
                  id="btn-edit-student-form"
                  data-qa="qt-edit-student-form"
                  i18n-text
                  text="Edit"
                  [uppercase]="true"
                  [buttonStyle]="'link'"
                  (buttonClick)="editForm($event, formIndexes.studentForm)"
                >
                </lx-button>
              </div>
            </div>
            <lx-button
              *ngIf="(studentFormValid$ | async) === true"
              class="price-request-form__tab-header__send-enquiry-button"
              id="btn-send-enquiry-from-header"
              data-qa="qt-send-enquiry-from-header"
              icon="pi pi-chevron-right"
              i18n-text
              text="Send enquiry"
              [style]="{ height: '72px' }"
              [hasText]="true"
              [block]="true"
              iconPos="after"
              [buttonStyle]="'primary'"
              (buttonClick)="sendEnquiry()"
            >
            </lx-button>
          </ng-container>
        </ng-template>
      </div>
    </ng-template>
    <ng-template pTemplate="content">
      <lx-price-request-student-form
        [columns]="1"
        [validationRequests]="validationRequests"
        [withValidationErrors]="formError ? (studentFormValid$ | async) === false : false"
        (validForm)="studentFormValid$.next($event)"
      ></lx-price-request-student-form>
      <div class="price-request-form__button-container">
        <lx-button
          [class.price-request-form__button-container__button--inline-cta]="withPriceRequestInlineCtaExperimentActive"
          class="price-request-form__button-container__button"
          id="btn-send-enquiry"
          data-qa="qt-send-enquiry"
          icon="pi pi-chevron-right"
          i18n-text
          text="Send enquiry"
          [hasText]="true"
          [block]="true"
          iconPos="after"
          [disabled]="formError ? (studentFormValid$ | async) === false : false"
          [uppercase]="true"
          [buttonStyle]="'primary'"
          (buttonClick)="sendEnquiry()"
        >
        </lx-button>
      </div>
    </ng-template>
  </p-accordionTab>
</p-accordion>
